/*
 * FunFungi · Oferta clara en la escalera de la ficha (03-11-2026, test 1 / 3x2 / 5x3, pedido de Mau:
 * «tipo lleva 3 paga 2, que quede claro cuál es la oferta»).
 * Dibuja a la izquierda de cada opción de la escalera de Shrine un frasquito por frasco que se lleva, con el color
 * de cada hongo: en un hongo suelto, todos de su color; en el Pack 4, uno de cada; en el dúo, los dos del dúo más el
 * hongo de regalo elegido (cambia al elegir otro). Además unifica la etiqueta de la oferta («¡Lleva 3, paga 2!»).
 * Solo dibuja: no toca precios ni el carrito (eso es ff-escalera.js y ff-atajos.js).
 * Datos: #ff-escalera-datos (metacampo de la escalera: familias, atajos, nombres_frasco).
 */
(function () {
  'use strict';
  if (window.FFOferta) return;
  var nodo = document.getElementById('ff-escalera-datos');
  var datos = null;
  try { datos = JSON.parse((nodo && nodo.textContent) || 'null'); } catch (e) { datos = null; }
  if (!datos) return;

  // Color de cada hongo (variables globales de snippets/ff-colores.liquid), por producto y por variante.
  var COLOR = { melena: 'var(--ff-melena, #3E8ED0)', reishi: 'var(--ff-reishi, #D6455B)', cordy: 'var(--ff-cordy, #F2A52B)', cola: 'var(--ff-cola, #2FA58C)' };
  var porProducto = { '9439161090329': 'melena', '9442027471129': 'reishi', '9442023866649': 'cordy', '9442035073305': 'cola' };
  var porVariante = { '50654144266521': 'melena', '50654133059865': 'reishi', '50654143578393': 'cordy', '50654132863257': 'cola' };
  var atajos = datos.atajos || {};
  var MAX = 5; // frascos dibujados; si son más, «+N»

  // El producto de la escalera: el del formulario que la contiene (sirve también en la landing «razones»).
  function productoDe(qb) {
    var f = qb.closest('form'), x = !f && qb.querySelector('input[form]');
    f = f || (x && document.getElementById(x.getAttribute('form')));
    var i = f && f.querySelector('input[name="product-id"]');
    if (i && i.value) return String(i.value);
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (m && m.id) return String(m.id);
    var g = document.querySelector('form[action*="/cart/add"] input[name="product-id"]');
    return g ? String(g.value) : null;
  }
  function frasco(color) {
    return '<svg class="ffo-f" viewBox="0 0 14 32" aria-hidden="true" focusable="false">' +
      '<path d="M5.4 1.6a1.6 1.6 0 0 1 3.2 0V7H5.4z" fill="#2B2622"/>' +
      '<rect x="3.9" y="6.4" width="6.2" height="4.4" rx=".9" fill="#2B2622"/>' +
      '<path d="M4.6 10.8h4.8v.9c0 .8 3.3 1.5 3.3 4.1v13.4a2 2 0 0 1-2 2H3.3a2 2 0 0 1-2-2V15.8c0-2.6 3.3-3.3 3.3-4.1z" fill="#8A4A1C" stroke="#fff" stroke-width=".9"/>' +
      '<rect x="1.75" y="18.2" width="10.5" height="7.4" rx=".6" fill="' + color + '"/>' +
      '<rect x="2.9" y="14" width="1.1" height="14.6" rx=".55" fill="#fff" opacity=".3"/>' +
      '</svg>';
  }
  // Lista de colores (uno por frasco) para la opción de `q` unidades del producto de la ficha.
  function colores(pid, q) {
    var a = atajos[pid];
    if (!a) return porProducto[pid] ? new Array(q + 1).join('x').split('').map(function () { return porProducto[pid]; }) : [];
    var lista = [];
    for (var i = 0; i < q; i++) a.variantes.forEach(function (v) { lista.push(porVariante[String(v)]); });
    if (a.regalo) {
      var r = window.FFAtajos && window.FFAtajos._regalo && window.FFAtajos._regalo.variante;
      var n = Number(a.regalo) * (a.regalo_por_pack ? q : 1);
      for (var j = 0; j < n; j++) lista.push(porVariante[String(r)] || 'regalo');
    }
    return lista;
  }
  function pintar() { document.querySelectorAll('quantity-breaks').forEach(pintarUna); }
  function pintarUna(qb) {
    var pid = productoDe(qb);
    if (!pid || (!porProducto[pid] && !atajos[pid])) return;
    if (!qb.dataset.ffoMirando) {
      qb.dataset.ffoMirando = '1';
      // Shrine rehace partes de la escalera al cambiar de variante.
      new MutationObserver(function (m) {
        if (m.some(function (x) { return !x.target.closest || !x.target.closest('.ffo-frascos'); })) pronto();
      }).observe(qb, { childList: true, subtree: true });
    }
    qb.classList.add('ffo');
    document.documentElement.classList.add('ffo-pagina'); // solo en páginas con escalera de extractos o packs
    // Con una sola opción (Pack 4) la pastilla «+N regalos» repite el bloque de regalos de abajo: se esconde.
    qb.classList.toggle('ffo--una', qb.querySelectorAll('label.quantity-break').length === 1);
    qb.querySelectorAll('label.quantity-break').forEach(function (l) {
      var q = Number(l.dataset.quantity || 1);
      var lista = colores(pid, q).filter(Boolean);
      if (!lista.length) return;
      var visibles = lista.length > MAX ? lista.slice(0, MAX - 1) : lista;
      var html = visibles.map(function (c) { return frasco(c === 'regalo' ? '#E9E1D3' : COLOR[c]); }).join('') +
        (lista.length > MAX ? '<span class="ffo-mas">+' + (lista.length - visibles.length) + '</span>' : '');
      var caja = l.querySelector('.ffo-frascos');
      if (!caja) {
        caja = document.createElement('span');
        caja.className = 'ffo-frascos';
        caja.setAttribute('aria-hidden', 'true');
        var donde = l.querySelector('.quantity-break__image-and-content');
        if (!donde) return;
        donde.insertBefore(caja, donde.firstChild);
      }
      caja.dataset.n = String(Math.min(lista.length, MAX));
      if (caja.innerHTML !== html) caja.innerHTML = html;
    });
  }

  var st = document.createElement('style');
  st.textContent =
    // Frasquitos: ancho fijo (el de 5) para que los textos de todas las opciones partan alineados.
    '.ffo .quantity-break__image-and-content{display:flex;align-items:center;gap:12px}' +
    '.ffo .quantity-break__content{flex:1;min-width:0}' +
    // Que nada empuje la tarjeta fuera de la pantalla: la columna de texto cede, la de precios no.
    '.ffo .quantity-break__left{min-width:0;flex:1 1 auto}.ffo .quantity-break__right{flex:0 0 auto}' +
    '.ffo-frascos{flex:0 0 60px;display:flex;align-items:flex-end;justify-content:flex-start;height:38px}' +
    '.ffo-f{width:15px;height:34px;flex:0 0 auto;filter:drop-shadow(0 1px 1px rgba(43,38,34,.2))}' +
    '.ffo-f+.ffo-f{margin-left:-4px}' +
    '.ffo-frascos[data-n="1"] .ffo-f{width:17px;height:38px}' +
    '.ffo-mas{margin-left:3px;font-size:12px;font-weight:700;line-height:1;color:#5c534b}' +
    // Título y bajada: la cantidad manda; la duración y el c/u, en gris.
    '.ffo .quantity-break__label-text{font-weight:700;white-space:nowrap}' +
    '.ffo .quantity-break__caption{color:#6b625a;font-weight:500;font-size:13px;letter-spacing:0;line-height:1.3}' +
    '.ffo .quantity-break__caption strong{font-weight:600}' +
    // La oferta: una sola etiqueta, sólida, en el color de la ficha.
    '.ffo label.quantity-break{overflow:visible}' +
    // Siempre adentro de la tarjeta, arriba a la derecha (los estilos de Shrine la sacaban por el borde).
    '.ffo .quantity-break__badge{position:absolute!important;top:0!important;right:14px!important;left:auto!important;bottom:auto!important;transform:translateY(-55%)!important;max-width:calc(100% - 28px);white-space:nowrap;margin:0!important;padding:4px 12px!important;background:var(--ffp-pag-boton, #2B2622)!important;color:#fff!important;border:0!important;border-radius:999px!important;box-shadow:0 2px 6px rgba(43,38,34,.18)!important;font-size:14.5px!important;font-weight:800!important;line-height:1.3!important;letter-spacing:.015em}' +
    '.ffo .quantity-break__badge::before,.ffo .quantity-break__badge::after{display:none!important}' +
    '.ffo .quantity-break__badge *{color:#fff!important}' +
    // «+2 regalos» en una línea: en celular se muestran menos fotitos.
    '.ffo .ffrg-qb__txt{white-space:nowrap}' +
    // 03-11 (Mau: «que se vea todo de un vistazo»): sin las pastillas «+N regalos» en las opciones (el bloque de
    // regalos de abajo ya los muestra), opciones más bajas, y sin el botón «Suma N más y llévate…» de ese bloque.
    '.ffo .ffrg-qb{display:none!important}' +
    '.ffo .quantity-break__wrapper{padding-top:9px!important;padding-bottom:9px!important}' +
    '.ffo .ffe-sube{font-size:11.5px;margin-top:1px}' +
    '.ffo-pagina .ffrg__boton,.ffo-pagina .ffrg__siguiente{display:none!important}' +
    // Landings «5 razones»: la compra de respaldo no muestra los % de la escalera vieja, y la tarjeta del dúo en la TDAH
    // va sin selector de cantidad (su precio tachado es el de 3 frascos: con 2 dúos no calzaría).
    '.ffr__pct{display:none!important}' +
    '[data-ffr-extra][data-pid="10643003015449"] [data-ffr-n]{display:none!important}' +
    // La etiqueta de la oferta va sobre el borde: aire arriba para que no tape el precio.
    '.ffo label.quantity-break:has(.quantity-break__badge){margin-top:14px}' +
    '.ffo label.quantity-break:has(.quantity-break__badge) .quantity-break__wrapper{padding-top:15px!important}' +
    '@media (max-width:420px){.ffo .ffrg-qb__foto:nth-child(n+3){display:none}}' +
    '@media (max-width:380px){.ffo .ffrg-qb__fotos{display:none}}' +
    '@media (max-width:420px){.ffo-frascos{flex-basis:50px;height:32px}.ffo-f{width:12.5px;height:29px}.ffo-frascos[data-n="1"] .ffo-f{width:14px;height:32px}.ffo-f+.ffo-f{margin-left:-3.5px}.ffo .quantity-break__image-and-content{gap:9px}.ffo .quantity-break__caption{font-size:12.5px}}' +
    // Celulares chicos (y el editor de Shopify en modo celular): todo un poco más compacto.
    '@media (max-width:380px){.ffo-frascos{flex-basis:38px;height:28px}.ffo-f{width:10px;height:24px}.ffo-frascos[data-n="1"] .ffo-f{width:12px;height:27px}.ffo-f+.ffo-f{margin-left:-3px}.ffo-mas{font-size:10.5px}' +
      '.ffo .quantity-break__image-and-content{gap:7px}.ffo .quantity-break__label-text{font-size:15px}.ffo .quantity-break__caption{font-size:12px}' +
      '.ffo .quantity-break__price{font-size:17px}.ffo .quantity-break__compare-price{font-size:13px}.ffo .ff-qb-ahorro{font-size:11px;white-space:normal}' +
      '.ffo .ffrg-qb{font-size:11.5px}.ffo .quantity-break__badge{font-size:13px!important;padding:3px 10px!important;right:10px!important}}';
  document.head.appendChild(st);

  var espera = null;
  function pronto() { clearTimeout(espera); espera = setTimeout(pintar, 60); }
  function iniciar() {
    pintar();
    // El hongo de regalo del dúo cambia los colores del último frasquito.
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.ffa-regalo')) pronto(); });
    document.addEventListener('shopify:section:load', pronto);
    // Escaleras que llegan después (landing «razones»): solo si al cargar no había ninguna, y hasta que aparezca.
    if (!document.querySelector('quantity-breaks')) {
      var obs = new MutationObserver(function (ms) {
        if (ms.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.tagName === 'QUANTITY-BREAKS' || (n.firstElementChild && n.querySelector('quantity-breaks'))); }); })) { obs.disconnect(); pronto(); }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  window.FFOferta = { pintar: pintar };
})();
